import { render } from "./MerchantApplication.vue?vue&type=template&id=490b595c&scoped=true"
import script from "./MerchantApplication.vue?vue&type=script&lang=js"
export * from "./MerchantApplication.vue?vue&type=script&lang=js"

import "./MerchantApplication.vue?vue&type=style&index=0&id=490b595c&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-490b595c"]])

export default __exports__